
  export const WORKFLOWS_RECEIVED = "WORKFLOWS_RECEIVED";
  export const SET_WORKFLOW = "SET_WORKFLOW";
  export const CREATE_WORKFLOW = "CREATE_WORKFLOW";
  export const SET_PROPERTY_WORKFLOW = "SET_PROPERTY_WORKFLOW";
  